// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"49364d8a","177":"647c8393","235":"95b91756","469":"a9305951","831":"1ce236d2","928":"2d6de584"}[chunkId] + ".chunk.js";
};